import type { CSSProperties } from 'react';

import { CREDIBILITY_LEAD, CREDIBILITY_SUB } from '../content/credibility';
import { useInView } from '../lib/useInView';

const quotes = [
  {
    text: 'I realised I could not debug without Copilot. Scary — and true.',
    attribution: 'Bootcamp grad · 4 months in',
  },
  {
    text: 'I finished the tutorials. I still freeze when they say "walk me through your solution."',
    attribution: 'Self-taught · year one',
  },
] as const;

export const SocialProof = () => {
  const { ref, inView } = useInView<HTMLElement>({ threshold: 0.2, once: true });

  return (
    <section
      ref={ref}
      className={`section proof${inView ? ' proof--revealed' : ''}`}
      aria-labelledby="proof-title"
    >
      <div className="container">
        <p className="eyebrow">Early signal</p>
        <h2 id="proof-title" className="h-section">
          No fake user counts. Real conversations.
        </h2>
        <p className="lede">{CREDIBILITY_LEAD}</p>
        <p className="proof__sub">{CREDIBILITY_SUB}</p>

        <div className="proof__quotes">
          {quotes.map((q, i) => (
            <blockquote
              key={q.attribution}
              className="proof__quote tile"
              style={{ '--card-i': i } as CSSProperties}
            >
              <p className="proof__quote-text">{`“${q.text}”`}</p>
              <footer className="proof__quote-attr">{q.attribution}</footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
